<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="handleSave"
        large
        ref="RkmModal"
        title="Orientação"
    >
        <Form
            :data="data"
            :model="model"
            @saved="saved"
            ref="Form"
        />

        <template #footer>
            <rkm-button @click="print()">
                Imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento.atendimentoMedico')
        }
    },
    data: () => ({
        model: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.model = {
                orientacoes: this.data.model.orientacoes,
            }

            this.$refs.RkmModal.show()
        },
        print() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.impressao.orientacoes(null, this.model)
                        .then(response => {

                            const content = new Blob([response.data], { type: response.headers['content-type'] })
                            const url = URL.createObjectURL(content)
                            const link = document.createElement('a')

                            link.href = url
                            link.target = '_blank'
                            link.click()

                            URL.revokeObjectURL(url);
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        handleSave() {
            this.$refs.Form.save()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        saved() {
            this.handleExit()
        },
    },
    mixins: [repository, error],
    props: {
        data: { type: Object, required: true },
    },
}
</script>